<template>
    <div>
        <h3>{{ $t("account.clubcard.title") }}</h3>
        <p class="font-weight-thin">{{ $t("account.clubcard.subTitle") }}</p>
        <p v-if="!clubcards.length" v-html="$t('account.clubcard.clubCardNotExists')"></p>
        <v-container v-else>
            <v-row v-for="card in clubcards" :key="card.id">
                <v-col>
                    <v-row no-gutters>                        
                        <v-col>Číslo karty: <strong>{{ card.number }}</strong></v-col>
                    </v-row>
                    <v-row no-gutters>                        
                        <v-col>Datum vydání: {{ new Date(card.issueDate).toLocaleString() }}</v-col>
                    </v-row>
                    <v-row v-if="card.validFrom" no-gutters>                        
                        <v-col>Platnost od: {{ new Date(card.validFrom).toLocaleDateString() }}</v-col>
                    </v-row>
                    <v-row v-if="card.validTo" no-gutters>                        
                        <v-col>Platnost do: {{ new Date(card.validTo).toLocaleDateString() }}</v-col>
                    </v-row>

                </v-col>

                <v-col class="v-col-auto">
                    <img width="100px" :src="card.qrCodeUrl" class="d-none d-lg-block"/>
                    <v-btn class="d-lg-none" :href="card.downloadUrl">Stáhnout</v-btn>
                </v-col>
            </v-row>
        </v-container>

    </div>
</template>
<script>
export default {
    name: 'Clubcard',
    components: {

    },
    mounted() {
        this.getClubcardInfo();
    },
    data() {
        return {
            clubcards: []
        }
    },
    methods: {
        getClubcardInfo() {
            window.axios
                .get(process.env.VUE_APP_ROOT_API + process.env.VUE_APP_API_ROOT + "/customeraccount/clubcards")
                .then(response => {
                    this.clubcards = response.data;
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }
}

</script>